import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const downloadExcel = (excelData, sheetName, fileName) => {
  //   const excelData = tableDataList.map((row) => ({
  //     "Branch Name": row?.branch_name || "",
  //     "Expense Name": row?.category_name || "",
  //     "Total Amount": row?.totalAmount || 0,
  //   }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(data, fileName);
};

export default downloadExcel;
